import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["postInstallLabel", "postInstallRoute", "postInstallOnClick"];
import { Button } from 'foundations-components/transitional/components/Button';
import { useDetailsPageContext } from '../context/DetailsPageContext';
import { navigateTo } from '../utils/DetailsPageUrls';
import { jsx as _jsx } from "react/jsx-runtime";
export function PostInstallButton(_ref) {
  let {
      postInstallLabel,
      postInstallRoute,
      postInstallOnClick
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    isEmbedded
  } = useDetailsPageContext();
  const handleOnClick = () => {
    if (postInstallRoute) {
      navigateTo(postInstallRoute, isEmbedded);
    }
    if (postInstallOnClick) {
      postInstallOnClick();
    }
  };
  return /*#__PURE__*/_jsx(Button, Object.assign({
    "data-test-id": "post-install-button",
    onClick: handleOnClick,
    use: "primary"
  }, rest, {
    children: postInstallLabel
  }));
}